// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2020." + "c87f71b5f51d18ccc3ca" + ".js";
};